var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4998 0.666748H1.49984C1.27882 0.666748 1.06686 0.754545 0.910582 0.910826C0.754301 1.06711 0.666504 1.27907 0.666504 1.50008V16.5001C0.666504 16.7211 0.754301 16.9331 0.910582 17.0893C1.06686 17.2456 1.27882 17.3334 1.49984 17.3334H16.4998C16.7208 17.3334 16.9328 17.2456 17.0891 17.0893C17.2454 16.9331 17.3332 16.7211 17.3332 16.5001V1.50008C17.3332 1.27907 17.2454 1.06711 17.0891 0.910826C16.9328 0.754545 16.7208 0.666748 16.4998 0.666748ZM5.6665 15.6667H2.33317V2.33341H5.6665V15.6667ZM15.6665 15.6667H7.33317V9.83341H15.6665V15.6667ZM15.6665 8.16675H7.33317V2.33341H15.6665V8.16675Z",
    fill: "#F4F5F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.c3858bed5ce9307261459499746ba8af.svg";
export { ForwardRef as ReactComponent };